"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownContainer = exports.Amount = exports.RightButton = exports.LeftButton = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  border-radius: ${props => props.theme.spacing.s1}px;
  ${props => !!(props === null || props === void 0 ? void 0 : props.maxWidth) && `max-width: ${props.maxWidth}px;`}
  ${props => !!(props === null || props === void 0 ? void 0 : props.minWidth) && `min-width: ${props.minWidth}px;`}
  height: ${props => props.theme.spacing.m6}px;
  display: flex;
  justify-content: space-between;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    width: 100%;
  }
`;
exports.LeftButton = styled_components_1.default.button `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.constants.blockWidth.s4}px;
  height: 100%;
  cursor: pointer;
  background: ${props => props.theme.palette.LIGHT_GRAY_20};
  border: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-radius: ${props => props.theme.spacing.s1}px 0px 0px ${props => props.theme.spacing.s1}px;
  flex-shrink: 0;
  user-select: none;
`;
exports.RightButton = styled_components_1.default.button `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.constants.blockWidth.s4}px;
  height: 100%;
  cursor: pointer;
  background: ${props => props.theme.palette.LIGHT_GRAY_20};
  border: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-radius: 0px ${props => props.theme.spacing.s1}px ${props => props.theme.spacing.s1}px 0px;
  flex-shrink: 0;
  user-select: none;
`;
exports.Amount = styled_components_1.default.input `
  width: 100%;
  display: flex;
  justify-content: center;
  border-top: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-bottom: 1px solid ${props => props.theme.palette.BLUE_GRAY_40};
  border-left: none;
  border-right: none;
  font-size: ${props => props.theme.typography.size.s3}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  line-height: ${props => props.theme.typography.lineHeight.l1}px;
  color: ${props => props.theme.palette.DARK_GRAY_100};
  user-select: none;
  text-align: center;
  min-width: 30px;
  :focus {
    outline: none;
  }
`;
exports.DropdownContainer = styled_components_1.default.div `
  width: 100%;
`;
exports.default = {
    Container: exports.Container,
    LeftButton: exports.LeftButton,
    RightButton: exports.RightButton,
    Amount: exports.Amount
};
